// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { SoftwareObservationSourceTypeSchema } from '../inputTypeSchemas/SoftwareObservationSourceTypeSchema'

/////////////////////////////////////////
// SOFTWARE OBSERVATION SCHEMA
/////////////////////////////////////////

export const SoftwareObservationSchema = z.object({
  sourceType: SoftwareObservationSourceTypeSchema,
  text: z.string(),
  timestamp: z.coerce.date().nullable(),
})

export type SoftwareObservation = z.infer<typeof SoftwareObservationSchema>

export default SoftwareObservationSchema;
